/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_TitleInputs */

const en_mk_cap_title = /** @type {(inputs: Mk_Cap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The things that make it usable every day`)
};

const id_mk_cap_title = /** @type {(inputs: Mk_Cap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hal-hal yang membuatnya layak dipakai setiap hari`)
};

/**
* | output |
* | --- |
* | "The things that make it usable every day" |
*
* @param {Mk_Cap_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_title = /** @type {((inputs?: Mk_Cap_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_title(inputs)
	return en_mk_cap_title(inputs)
});